<template>
  <main class="land-page">
    <img class="land-logo" src="../../static/images/land/logo.png" alt="Go Quiz">
    <img class="land-title-art" src="../../static/images/land/land_text.png" alt="">
    <img class="land-prize-art" src="../../static/images/land/main_prize.png" alt="">

    <section class="land-package-picker" :aria-label="$t('select')">
      <div class="land-package-heading">
        <img src="../../static/images/land/package_line.png" alt="">
        <span>{{$t('select')}}</span>
      </div>
      <div class="land-package-actions">
        <button
          v-if="showDaily"
          type="button"
          class="land-package-button land-package-button-daily"
          :class="{'is-active': type === 'daily'}"
          @click="getType('daily')"
        >
          <span>{{$t('Daily')}}</span>
        </button>
        <button
          v-if="showWeekly"
          type="button"
          class="land-package-button land-package-button-weekly"
          :class="{'is-active': type === 'weekly'}"
          @click="getType('weekly')"
        >
          <span>{{$t('Weekly')}}</span>
        </button>
      </div>
    </section>

    <div v-if="show_usub" class="land-unsub-tip">{{$t('unsub_tip')}}</div>

    <nav class="land-footer" aria-label="Support links">
      <button type="button" class="land-footer-link" @click="push('termsAndCondition')">
        {{$t('AccountTC')}} <span class="app-en">&gt;&gt;</span>
      </button>
      <button type="button" class="land-footer-link" @click="push('faq')">
        {{$t('AccountFAQ')}} <span class="app-en">&gt;&gt;</span>
      </button>
    </nav>
	</main>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        password:'',
        type:'daily',
        showDaily: true,  // 控制 daily 的显示
        showWeekly: true,  // 控制 weekly 的显示
        show_usub: false,  // 控制 weekly 的显示
      }
    },
	created(){
    this.report_page();
    console.log('created');
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if (this.$route.query.mobile){
      let that = this
      that.mobile = this.$route.query.mobile;
    }
    var type  = this.$route.query.type
    if (type === 'day'){
      this.showDaily = true
      this.showWeekly = false
    }else if(type === 'week'){
      this.showWeekly = true
      this.showDaily = false
    }else{
      this.showDaily = true
      this.showWeekly = true
    }
	},
  mounted(){
    console.log('mounted');
    //如果携带号码直接订阅daily
    // if (this.mobile){
    //   this.goLogin()
    // }
  },
    methods: {
      getType(type){
        this.type = type
        this.goLogin()
      },
      back(){
        this.$router.go(-1);
      },
      push(path){
        this.$router.push({path:path});
      },
		  goLogin(){
        let that = this
        let queryParams = this.$route.query;
        if(!that.mobile){
          //没有号码直接跳登录页面
          that.$router.push({path:'/login',query: {...queryParams,type:that.type}})
        }else{
          //有号码直接订阅登录
          that.$parent.loadModal(true);
          let mobile = this.mobile
          let type  = this.type
          delete queryParams.mobile; // 删除 mobile，避免 URL 里重复
          delete queryParams.type; // 删除 type，避免 URL 里重复
          let queryString = Object.keys(queryParams).length
            ? '&' + Object.entries(queryParams)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&')
            : '';
          let url = '/api/user/sub?mobile='+mobile +'&type='+type+queryString
          that.$api.get(url, {},r =>{
            that.$parent.returnCode(r,function(){
              that.$parent.loadModal(false);
              if (r.code == 1){
                that.$parent.returnCode(r,function(){
                  localStorage.setItem('token',r.data.userinfo.token)
                  localStorage.setItem('mobile',r.data.userinfo.mobile)
                  that.$router.push('/');
                });
              }else{
                that.$utils.alertText(r.msg,80, 3000);
              }
            });

          })
        }
		  },
      report_page(){
        let that = this
        let mobile = this.$route.query.mobile;
        let data = {'type': 'land','mobile':mobile}
        that.$api.post('/api/report/process', data, r => {
          that.$parent.returnCode(r, function () {
            that.show_usub = r.data.show_usub
          })
        })
      }
	}
}
</script>
<style scoped>
.land-page {
  position: relative;
  width: 100%;
  min-height: 196vw;
  min-height: max(100svh, 196vw);
  overflow: hidden;
  color: #fff;
  background: #080036 url('../../static/images/land/main_bg.jpg') center top / 100% 100% no-repeat;
}

.land-logo,
.land-title-art,
.land-prize-art,
.land-package-heading img {
  display: block;
  user-select: none;
  pointer-events: none;
}

.land-logo {
  position: absolute;
  z-index: 3;
  top: 4.8%;
  left: 50%;
  width: 17.5%;
  transform: translateX(-50%);
}

.land-title-art {
  position: absolute;
  z-index: 2;
  top: 14.1%;
  left: 50%;
  width: 94%;
  transform: translateX(-50%);
}

.land-prize-art {
  position: absolute;
  z-index: 1;
  top: 4.9%;
  left: 50%;
  width: 100%;
  transform: translateX(-50%);
}

.land-package-picker {
  position: absolute;
  z-index: 4;
  top: 67.2%;
  right: 6.8%;
  left: 6.8%;
}

.land-package-heading {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  color: #fff;
  font-size: clamp(17px, 4.5vw, 34px);
  font-weight: 500;
  line-height: 1;
  text-align: center;
  text-shadow: 0 2px 4px rgba(72, 0, 72, .8);
}

.land-package-heading img {
  position: absolute;
  top: 50%;
  left: 50%;
  height: auto;
  transform: translate(-50%, -50%);
}

.land-package-heading span {
  position: relative;
  z-index: 1;
  padding: 0 4.8%;
  background: transparent;
}

.land-package-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4.5%;
  margin-top: 7.2%;
}

.land-package-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 47.75%;
  min-height: 0;
  aspect-ratio: 443 / 167;
  padding: 0 15%;
  border: 0;
  border-radius: 999px;
  color: #fff;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  font-family: inherit;
  font-size: clamp(18px, 5.7vw, 43px);
  font-weight: 900;
  line-height: 1;
  letter-spacing: .02em;
  text-align: center;
  text-transform: uppercase;
  text-shadow: 0 3px 0 rgba(104, 0, 57, .72), 0 5px 8px rgba(59, 0, 55, .42);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform .16s ease, filter .16s ease;
}

.land-package-button-daily { background-image: url('../../static/images/land/daily_btn_bg.png'); }
.land-package-button-weekly { background-image: url('../../static/images/land/weekly_btn_bg.png'); }

.land-package-button.is-active,
.land-package-button:active {
  filter: brightness(1.08) saturate(1.08);
  transform: translateY(1.5%);
}

.land-unsub-tip {
  position: absolute;
  z-index: 4;
  top: 82.2%;
  right: 9%;
  left: 9%;
  color: #ffe675;
  font-size: clamp(13px, 3.5vw, 27px);
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
  text-shadow: 0 2px 5px rgba(64, 0, 38, .9);
}

.land-footer {
  position: absolute;
  z-index: 4;
  right: 13%;
  bottom: 3.7%;
  left: 13%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.land-footer-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26%;
  padding: 0;
  border: 0;
  color: #fff;
  background: transparent;
  font-family: inherit;
  font-size: clamp(15px, 4.4vw, 34px);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -.02em;
  text-shadow: 0 3px 5px rgba(27, 0, 63, .9);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.land-footer-link:active { transform: translateY(1px); }
</style>



// WEBPACK FOOTER //
// src/page/land.vue